/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IOrderUploadViewProps } from './order-upload';

export default (props: IOrderUploadViewProps) => {
    return <>{props.dropzone}</>;
};
